import React, { useEffect, useRef, useState } from "react";
import "./Test.css";
import img1 from "./img1.jpeg";
import img2 from "./img2.jpg";
import img3 from "./img3.jpg";
import { Star, RefreshCw } from "lucide-react";
import retroMicImg from "../assets/assets/retro-mic.png";

const testimonials = [
  {
    id: 1,
    name: "Dr. Siddhartha Goel",
    role: "AI & ML DIRECTOR",
    text: "PINKMOON Tech exceeded our expectations with exceptional AI expertise and outstanding project execution.",
    image: img1,
    glow: "rgba(244, 114, 182, 0.3)",
  },
  {
    id: 2,
    name: "Karthik",
    role: "ENTERPRISE CLIENT",
    text: "PINKMOON Technologies delivered a brilliant solution that streamlined our business workflows completely.",
    image: img2,
    glow: "rgba(56, 189, 248, 0.3)",
  },
  {
    id: 3,
    name: "John Doe",
    role: "OPERATIONS LEAD",
    text: "Working with PINKMOON Tech has been a game-changer for our operational efficiency and digital growth.",
    image: img3,
    glow: "rgba(251, 191, 36, 0.3)",
  },
  {
    id: 4,
    name: "Ajay Kumar",
    role: "BUSINESS HEAD",
    text: "Highly impressed by PINKMOON's technical excellence, customer-first approach, and prompt project delivery.",
    image: img2,
    glow: "rgba(192, 132, 252, 0.3)",
  },
  {
    id: 5,
    name: "Abhishek",
    role: "PRODUCT MANAGER",
    text: "PINKMOON Tech transformed our vision into a top-quality, scalable enterprise platform seamlessly.",
    image: img1,
    glow: "rgba(251, 146, 60, 0.3)",
  },
  {
    id: 6,
    name: "Latha Kumari",
    role: "STRATEGY DIRECTOR",
    text: "Outstanding digital solutions and reliable support — PINKMOON Technologies is truly a trusted tech partner.",
    image: img3,
    glow: "rgba(45, 212, 191, 0.3)",
  },
];

const TestimonialSection = () => {
  const [visibleCount, setVisibleCount] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted) {
          setHasStarted(true);
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasStarted]);

  useEffect(() => {
    if (!hasStarted) return;

    if (visibleCount < testimonials.length) {
      const timer = setTimeout(() => {
        setVisibleCount((prev) => prev + 1);
      }, 1100);
      return () => clearTimeout(timer);
    }
  }, [hasStarted, visibleCount]);

  const handleReplay = () => {
    setVisibleCount(0);
    setTimeout(() => {
      setVisibleCount(1);
    }, 100);
  };

  return (
    <section className="testimonials-staggered-section" ref={sectionRef}>
      <div className="testimonials-header">
        <h2 className="testimonials-title">What Our Customers Say</h2>
        <p className="testimonials-subtitle">
          Trusted by forward-thinking teams worldwide
        </p>
      </div>

      <div className="testimonials-flow-container">
        {/* Left Side Retro Metallic Studio Microphone Badge */}
        <div className="testimonial-mic-box">
          <div className="mic-circle-outer">
            <div className="mic-pulse-ring ring-1"></div>
            <div className="mic-pulse-ring ring-2"></div>
            <div className="mic-pulse-ring ring-3"></div>
            <div className="mic-retro-img-wrap">
              <img
                src={retroMicImg}
                alt="Retro Studio Microphone"
                className="retro-mic-photo"
              />
            </div>
          </div>
          <span className="mic-label">VOICE OF CLIENTS</span>

          <button className="replay-stream-btn" onClick={handleReplay}>
            <RefreshCw size={13} />
            <span>Watch Flow</span>
          </button>
        </div>

        {/* Right Side: Flowing Perfect Circle Cards in 2 Neat Rows */}
        <div className="testimonials-two-rows-grid">
          {testimonials.map((item, index) => {
            const isCardVisible = index < visibleCount;

            return (
              <div
                key={item.id}
                className={`circle-card-wrapper ${isCardVisible ? "card-emerged" : "card-hidden"
                  }`}
              >
                {isCardVisible && (
                  <>
                    {/* Ambient Soft Circular Aura Glow */}
                    <div
                      className="staggered-card-glow circle-glow"
                      style={{ background: item.glow }}
                    ></div>

                    {/* Frosted Glass Perfect Circle Card */}
                    <div className="staggered-card-content perfect-circle-card">
                      {/* Profile Avatar with Verified Star Badge */}
                      <div className="staggered-avatar-box">
                        <img
                          src={item.image}
                          alt={item.name}
                          className="staggered-avatar-img"
                        />
                        <div className="verified-star-badge">
                          <Star size={8} fill="#ffffff" color="#ffffff" />
                        </div>
                      </div>

                      {/* Name & Role */}
                      <h3 className="staggered-card-name">{item.name}</h3>
                      <span className="staggered-card-role">{item.role}</span>

                      {/* Quote Text */}
                      <p className="staggered-quote-text circle-quote-text">
                        "{item.text}"
                      </p>
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
